import useGetAccount from './useGetAccount'

/**
 * Returns true when the AI Assistant is enabled for the current user:
 * either their team has it on (`team.settings.ai_chatbot_enabled`) or they
 * carry a per-user staged-rollout override (`settings.ai_chatbot_enabled`).
 * Both flags are toggled by superadmins in Django admin. `??` mirrors the
 * backend's tri-state semantics: an explicit true/false override always
 * wins (staged rollout / deliberate per-user block); null or absent
 * inherits the team flag.
 *
 * Drives sidebar visibility and the `/assistant` route guard.
 */
const useGetIsAiChatbotEnabled = (): boolean => {
  const account = useGetAccount()
  return !!(account?.settings?.ai_chatbot_enabled ?? account?.team?.settings?.ai_chatbot_enabled)
}

export default useGetIsAiChatbotEnabled
